import React from "react";
import { Layout, UserInfo } from "../../components";
const ProfilePage = () => {
  return (
    <Layout>
      <UserInfo />
    </Layout>
  );
};

export default ProfilePage;
